import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Release } from '../../models/release';
import { UtilityService } from '../utility/utility.service';

@Injectable({
  providedIn: 'root',
})
export class SuiteService {
  private utilityService = inject(UtilityService);

  suiteEndpoint = `${environment.testHubApiUrl}/v1/Suite`;

  getDetailByReleaseId(releaseId: number): Observable<Release> {
    return this.utilityService.getRequest<Release>(`${this.suiteEndpoint}/${releaseId}`);
  }

  getSuitesFromAzureByRelease(releaseId: number, rootSuiteAzureId: number) {
    return this.utilityService.getRequest<any[]>(
      `${this.suiteEndpoint}/${releaseId}/${rootSuiteAzureId}`,
    );
  }
}
